import { useEffect } from 'react'

import { RichTextEditor } from '@mantine/tiptap'
import { useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'

interface JobDescriptionEditorProps {
  value: string
  onChange?: (html: string) => void
  editable?: boolean
}

const JobDescriptionEditor = ({
  value,
  onChange,
  editable = true,
}: JobDescriptionEditorProps) => {
  const editor = useEditor({
    editable,
    extensions: [
      StarterKit.configure({
        heading: false,
        orderedList: false,
        strike: false,
        code: false,
        codeBlock: false,
        blockquote: false,
        horizontalRule: false,
      }),
    ],
    content: value || '',
    onUpdate: ({ editor }) => {
      onChange?.(editor.isEmpty ? '' : editor.getHTML())
    },
  })

  useEffect(() => {
    editor?.setEditable(editable)
  }, [editable, editor])

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value || '', false)
    }
  }, [value, editor])

  return (
    <RichTextEditor
      editor={editor}
      variant="subtle"
      className="job-description-editor"
    >
      {editable && (
        <RichTextEditor.Toolbar>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
          </RichTextEditor.ControlsGroup>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.BulletList />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>
      )}
      <RichTextEditor.Content />
    </RichTextEditor>
  )
}

export default JobDescriptionEditor
